import { Card, Form, Button } from "react-bootstrap";
import { useState, useContext } from "react";

import GenericModalNote from "../Modal/GenericModalNote";
import AppContext from "../../store/AppContext";

import Loader from "react-spinners/BarLoader";
import FamilyService from "../../services/tfamily.service";

function CollectiveCreate(props) {
  const appContext = useContext(AppContext);
  const [newFamily, setNewFamily] = useState({
    adminPhone: "",
    memberPhone: "",
  });
  const [loading, setLoading] = useState(false);

  const createFamily = async ({ adminPhone, memberPhone, note }) => {
    try {
      setLoading(true);
      await FamilyService.createTFamily(adminPhone, memberPhone, note);
      props.notify("tr", "success", `Коллектив групп-г ажилттай үүсгэлээ.`);
      appContext.refreshConsumer();
    } catch (err) {
      props.notify("tr", "danger", err.message);
    } finally {
      setLoading(false);
    }
  };
  return (
    <Card>
      {loading ? <Loader /> : null}
      <Card.Header>
        <Card.Title as="h4">Collective үүсгэх</Card.Title>
      </Card.Header>

      <Card.Body>
        <Form>
          <Form.Group>
            <label>Admin Phone Number</label>
            <Form.Control
              value={newFamily?.adminPhone || ""}
              placeholder="Admin Phone Number"
              type="number"
              onChange={(e) => {
                setNewFamily((prev) => ({
                  ...prev,
                  adminPhone: e.target.value,
                }));
              }}
            ></Form.Control>
            <label>Member Phone Number</label>
            <Form.Control
              value={newFamily?.memberPhone || ""}
              placeholder="Member Phone Number"
              type="number"
              onChange={(e) => {
                setNewFamily((prev) => ({
                  ...prev,
                  memberPhone: e.target.value,
                }));
              }}
            ></Form.Control>
          </Form.Group>
          <GenericModalNote
            onClick={createFamily}
            params={{
              adminPhone: newFamily.adminPhone,
              memberPhone: newFamily.memberPhone,
            }}
            action={"Групп үүсгэх"}
            title={"Групп үүсгэх"}
            body={`Та админ ${newFamily.adminPhone} гишүүн ${newFamily.memberPhone} дугаартай  групп үүсгэхдээ итгэлтэй байна уу?`}
          />
        </Form>
      </Card.Body>
    </Card>
  );
}
export default CollectiveCreate;
